import type { QueryClient } from "@tanstack/react-query";
import { RD_SCHEDULE_WEEK_QUERY_PREFIX } from "../../lib/rd-schedule-week.js";

// NO-912. Which reads a saved appointment can show up in.

/**
 * Every read an appointment can show up in: the Week, the Upcoming list and a
 * Past week. Only the reads on screen refetch; the rest are marked stale.
 */
export const APPOINTMENT_READ_PREFIXES = [
  RD_SCHEDULE_WEEK_QUERY_PREFIX,
  ["appointments"],
  ["appointments-past-week"],
] as const;

export function refreshAppointmentReads(queryClient: QueryClient): void {
  for (const queryKey of APPOINTMENT_READ_PREFIXES) {
    void queryClient.invalidateQueries({ queryKey: [...queryKey] });
  }
}
